import React from 'react';
import PropTypes from 'prop-types';

import ArrowBack from '@material-ui/icons/ArrowBack';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import ClearIcon from '@material-ui/icons/Clear';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

class AddAttributeDialogItem extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    handleBackClick: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    availableAttributes: PropTypes.array.isRequired,
    globalConfig: PropTypes.object.isRequired,
    handleAddAttributes: PropTypes.func,
  };

  state = {
    checked: [],
  };

  handleToggle = value => {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    this.setState({
      checked: newChecked,
    });
  };

  handleAddButtonClick = () => {
    const attributes = this.state.checked;
    this.props.handleAddAttributes(attributes);
    this.props.handleClose();
  };

  render() {
    const { classes, availableAttributes } = this.props;

    return (
      <>
        <DialogTitle>
          <div className={classes.titleContainer}>
            <div className={classes.leftHeader}>
              <IconButton aria-label="back" onClick={this.props.handleBackClick}>
                <ArrowBack />
              </IconButton>
              <div>
                <Typography variant="h5">Add an attribute</Typography>
                <Typography variant="body2">
                  You may only add longer form attributes such as long text or collections to the
                  root profile layout. To add shorter form attributes to your page, add them to a
                  new or existing Category instead.
                </Typography>
              </div>
            </div>
            <div>
              <IconButton aria-label="close" onClick={this.props.handleClose}>
                <ClearIcon />
              </IconButton>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <List className={classes.list}>
            {availableAttributes.map(arrayValue => (
              <ListItem
                className={classes.listItem}
                key={arrayValue.id}
                button
                onClick={() => this.handleToggle(arrayValue)}
              >
                <Checkbox
                  disableRipple
                  checked={this.state.checked.indexOf(arrayValue) !== -1}
                  tabIndex={-1}
                />
                <ListItemText primary={`${arrayValue.displayName}`} />
              </ListItem>
            ))}
          </List>
          <Typography variant="body2">
            There are no more attributes that can be added! Go to the “Attributes” tab to create
            additional attributes.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button className={classes.buttons} onClick={this.props.handleClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={this.handleAddButtonClick}
            color="secondary"
            disabled={this.state.checked.length <= 0}
          >
            Save
          </Button>
        </DialogActions>
      </>
    );
  }
}

export default AddAttributeDialogItem;
